export default __webpack_public_path__ + "static/media/payroll.cf2a0557.png";